import { TemplateEmail } from "../../models/email-message";

export namespace TemplateEmails
{
    export class LoadEmailTemplates {
        static readonly type = "[Email Service] Email templates loaded"
        constructor(){};
    }
    export class EmailServiceEmailTemplateAdded
    {
        static readonly type = "[Email Service] Email template added"
        constructor(public payload: {templateEmail: TemplateEmail}){};
    }
    export class EmailServiceEmailTemplateSaved
    {
        static readonly type ="[Email Service] Email template saved";
        constructor(public payload:{templateEmail: TemplateEmail}){};
    }
    
    export class EmailServiceEmailTemplateDeleted
    {
        static readonly type ="[Email Service] Email template deleted";
        constructor(public payload:{templateEmailId: number}){};
    }
}